import cookie from 'react-cookies';

// cookie保留时间
const expires = new Date()
expires.setDate(Date.now() + 1000 * 60 * 60 * 24 * 14)

//1. 设置可保留的值
export function setCookie(key, value) {
    cookie.save(key, value, {
        path: '/',
        expires,
        // maxAge: 1000,
        // domain: 'https://play.bukinoshita.io',
        // secure: true

    });
}

// 2.获取可保留的值
export function getCookie(key) {
    const loadAccount = cookie.load(key);
    return loadAccount;  
}

//  3.认证可保留的值
export function hasCookie(key) {
    const value = cookie.load(key);
    if (value === undefined) {
        return false;
    } else {
        return true;
    }
}

//  4.移除可保留的值
export function removeCookie(key) {
    cookie.remove(key, { path: "/" })
}
